var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArianeinBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 157.58 30.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 214.16,
    y1: 51.25,
    x2: 371.74,
    y2: 51.25,
    gradientTransform: "translate(-214.16 66.53) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#251142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354f8b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.11,11.04c0-6.93-4.88-11.04-12.32-11.04h-12.07V5.65h11.81c3.85,0,5.9,2.05,5.9,5.39,0,2.57-1.28,4.36-3.85,5.13h-13.86v14.38h6.42v-8.47h5.9l5.65,8.47h6.93l-6.42-9.75c3.6-1.81,5.91-5.14,5.91-9.76Zm3.6,19.51h6.11V0h-6.11V30.55ZM12.18,0L0,30.53H6.38l1.74-5.39,.77-1.74,2.51-6.77,3.87-9.86,8.7,23.76h6.58L18.37,0h-6.19ZM84.12,0l-12.18,30.53h6.38l1.74-5.39,.77-1.74,2.51-6.77,3.87-9.86,8.7,23.76h6.57L90.3,0h-6.18Zm52.08,0V5.35h21.38V0h-21.38Zm6.11,17.56h12.98v-5.35h-19.09V30.54h21.38v-6.11h-15.27v-6.87h0Zm-16.38,1.03L111.98,0h-5.31V30.55h6.64V11.96l13.95,18.59h5.31V0h-6.64V18.59Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArianeinBlue);
export default __webpack_public_path__ + "static/media/Ariane in Blue.6fdc8a30ccb30e6e45fde80220e4bab2.svg";
export { ForwardRef as ReactComponent };